import { TopPageLinksProps, PageLink } from './TopPageLinks.component';
import TopPageLinks from './TopPageLinks.container';

export type { TopPageLinksProps as TopPageLinksTypes, PageLink };

export default TopPageLinks;
